import { cardNode } from "../fragments/cardNode";
import {
    widgetNode,
    PageNode,
    pageBody,
    pageSupplementaryBody,
    TrackingNode,
} from "../fragments/page";

export function page(path, isPreview) {
    return `
        query Page ($lineupSwap: JSONObject) {
            page(${path}, lineupSwap: $lineupSwap, targets: [WEB,ALL]) {
                ...body
            }
        }
        ${pageBody(isPreview)}
        ${cardNode}
        ${widgetNode}
        ${PageNode}
        ${TrackingNode}
    `;
}

export function pageSupplementaryData(path, isDetail) {
    return `
        query pageSupplementaryData {
            page(${path}, targets: [WEB,ALL]) {
                ...supplementaryBody
            }
        }
        ${pageSupplementaryBody(isDetail)}
        ${!isDetail ? cardNode : ""}
        ${!isDetail ? widgetNode : ""}
        ${!isDetail ? PageNode : ""}
    `;
}

export function pageMetaData(path) {
    return `
        query PageMetaData {
            page(${path}, targets: [WEB,ALL]) {
                title
                description
                path
                section {
                    tracking{
                        ...TrackingNode
                    }
                    attributionLevels
                }
                metadata {
                    description
                }
            }
        }
        ${TrackingNode}
    `;
}
